<template>
  <van-dialog
    v-model:show="showDialog"
    title="登录"
    width="85%"
    :close-on-click-overlay="true"
    :before-close="onBeforeClose"
  >
    <div class="login-dialog-content">
      <van-form ref="formRef" @submit="onSubmit">
        <van-field
          v-model="formData.username"
          name="username"
          label="用户名"
          placeholder="请输入用户名"
          :rules="[{ required: true, message: '请输入用户名' }]"
        />
        <van-field
          v-model="formData.password"
          type="password"
          name="password"
          label="密码"
          placeholder="请输入密码"
          :rules="[{ required: true, message: '请输入密码' }]"
        />
        
        <div class="login-actions">
          <van-button 
            round 
            block 
            type="primary" 
            native-type="submit"
            :loading="loading"
          >
            登录
          </van-button>
          <div class="register-link">
            <span>还没有账号？</span>
            <span class="link" @click="goToRegister">立即注册</span>
          </div>
        </div>
      </van-form>
    </div>
  </van-dialog>
</template>

<script>
import { ref, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { showSuccessToast } from 'vant'

export default {
  name: 'LoginDialog',
  setup() {
    const router = useRouter()
    const store = useStore()

    const showDialog = ref(false)
    const loading = ref(false)
    const formRef = ref(null)

    const formData = reactive({
      username: '',
      password: ''
    })

    const show = () => {
      showDialog.value = true
    }

    const hide = () => {
      showDialog.value = false
    }

    const onBeforeClose = () => {
      return !loading.value
    }

    const onSubmit = async () => {
      loading.value = true
      try {
        await store.dispatch('user/login', formData)
        showSuccessToast('Login successful')
        showDialog.value = false
        window.location.reload()
      } catch (error) {
        console.error('Login failed', error)
      } finally {
        loading.value = false
      }
    }

    const goToRegister = () => {
      showDialog.value = false
      router.push('/register.html')
    }

    // 全局监听登录事件
    window.addEventListener('show-login', () => {
      show()
    })

    return {
      showDialog,
      loading,
      formRef,
      formData,
      show,
      hide,
      onBeforeClose,
      onSubmit,
      goToRegister
    }
  }
}
</script>

<style scoped lang="stylus">
.login-dialog-content 
  padding: 20px 16px 10px
.login-actions 
  margin-top: 20px
.register-link 
  text-align: center
  margin-top: 16px
  font-size: 14px
  color: #666
  .link 
    color: #1989fa
    cursor: pointer
    margin-left: 4px
    &:active 
      opacity: 0.7
</style>